import { render } from "./BanobagiMarketplacePanel.vue?vue&type=template&id=13a4493f&scoped=true"
import script from "./BanobagiMarketplacePanel.vue?vue&type=script&lang=js"
export * from "./BanobagiMarketplacePanel.vue?vue&type=script&lang=js"

import "./BanobagiMarketplacePanel.vue?vue&type=style&index=0&id=13a4493f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a4493f"]])

export default __exports__